export const TRACKING_PROVIDER = {
  // META: "meta",
  // TIKTOK: "tiktok",
  GTM: "gtm",
  NETCORE: "netcore",
};
